// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   Landing Page - Flat Design System
   Uses CSS variables from colors.css
   =================================== */

* {
  box-sizing: border-box;
}

.landing-content {
  min-height: 100%;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  width: 100%;
}

.landing-content.landing-authenticated {
  min-height: 100vh;
  display: block;
  overflow-y: auto;
}

.landing-gradient {
  display: none;
}

.landing-main {
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  padding: 18vh clamp(20px, 5vw, 32px) 60px;
  text-align: center;
  position: relative;
  z-index: 5;
  min-height: 70vh;
  min-height: 70dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.landing-main > *,
.landing-hero > * {
  width: 100%;
}

.landing-main > .landing-announcement-chip,
.landing-hero > .landing-announcement-chip {
  width: auto;
}

/* Hero wrapper is layout-transparent by default (logged-out view unchanged) */
.landing-hero {
  display: contents;
}

.landing-content.landing-authenticated .landing-main {
  max-width: 980px;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 48px clamp(20px, 5vw, 32px);
  justify-content: center;
}

.landing-content.landing-authenticated .landing-title {
  margin-bottom: 28px;
}

/* Center the authenticated composer within the available viewport. */
.landing-content.landing-authenticated .landing-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.landing-content.landing-authenticated .landing-hero > form,
.landing-content.landing-authenticated .landing-hero > .landing-shortcut-hint {
  width: 100%;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}

.landing-content.landing-authenticated .landing-template-section {
  margin-top: 24px;
}

.landing-content.landing-authenticated .landing-template-section {
  text-align: center;
}

.landing-content.landing-authenticated .landing-template-section__header {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.landing-content.landing-authenticated .landing-template-grid {
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}

.landing-title {
  margin: 0 0 clamp(24px, 5vh, 40px) 0;
  font-size: clamp(36px, 4.5vw, 52px);
  font-weight: 400;
  line-height: 1.1;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.landing-title-em {
  font-style: italic;
}

.landing-announcement-chip {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  margin: 0 0 16px;
  border: 1px solid var(--color-border-input);
  border-radius: 999px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
  line-height: 1.3;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.landing-announcement-chip:hover {
  background: var(--color-bg-user-bubble);
}

.landing-announcement-chip:focus-visible {
  outline: 2px solid var(--color-text-primary);
  outline-offset: 2px;
}

.landing-announcement-chip strong {
  font-weight: 700;
}

.landing-announcement-emoji {
  line-height: 1;
  transform: translateY(-1px);
}

.landing-announcement-arrow {
  display: inline-flex;
  line-height: 1;
  transform: translateX(0);
  transition: transform 0.2s ease;
}

.landing-announcement-chip:hover .landing-announcement-arrow,
.landing-announcement-chip:focus-visible .landing-announcement-arrow {
  transform: translateX(4px);
}

.landing-typewriter {
  display: inline-block;
  min-width: 0.5ch;
}

.landing-cursor {
  display: inline-block;
  animation: blink 1s step-end infinite;
  margin-right: 0px;
  color: var(--color-text-secondary);
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}

/* ═══════════════════════════════════════════════════════════════
   Upload Panel - Flat Design
   ═══════════════════════════════════════════════════════════════ */

.landing-upload-panel {
  background: var(--color-bg-canvas-surface);
  border-radius: 6px;
  padding: 20px 24px 72px 24px;
  border: 1px solid var(--color-border-input);
  position: relative;
  min-height: 160px;
}

.landing-upload-input {
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  line-height: 1.6;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.landing-upload-input::placeholder {
  color: var(--color-text-secondary);
}

.landing-upload-placeholder {
  margin: 0;
  font-size: 14px;
  color: var(--color-text-secondary);
}

/* ═══════════════════════════════════════════════════════════════
   Attachments
   ═══════════════════════════════════════════════════════════════ */

.landing-attachments-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: -16px;
  margin-left: -16px;
  align-items: flex-end;
}

.landing-reference-chips {
  display: contents;
}

.landing-reference-menu {
  left: 16px;
  width: min(340px, calc(100vw - 40px));
}

/* ── Asset image chip (inside attachments grid) ── */
.landing-asset-chip {
  padding: 4px 8px 4px 4px;
}

.landing-asset-chip-thumb {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 3px;
  flex-shrink: 0;
  display: block;
}

/* ── @mention dropdown ── */
.landing-mention-dropdown {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  width: 280px;
  max-height: 240px;
  overflow-y: auto;
  z-index: 200;
}

.landing-mention-dropdown-label {
  padding: 6px 10px 4px;
  font-size: 10px;
  font-weight: 700;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.landing-mention-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  cursor: pointer;
  transition: background 0.1s ease;
}

.landing-mention-item:hover,
.landing-mention-item--selected {
  background: var(--color-bg-input);
}

.landing-mention-thumb {
  width: 34px;
  height: 34px;
  border-radius: 3px;
  object-fit: cover;
  flex-shrink: 0;
  background: var(--color-bg-input);
}

.landing-mention-thumb-empty {
  width: 34px;
  height: 34px;
  border-radius: 3px;
  background: var(--color-bg-input);
  flex-shrink: 0;
}

.landing-mention-item-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.landing-mention-item-name {
  font-size: 13px;
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

.landing-mention-item-sub {
  font-size: 11px;
  color: var(--color-text-secondary);
}

.landing-pdf-chip {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-size: 11px;
  position: relative;
}

.landing-pdf-extension {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: var(--color-bg-user-bubble);
  color: var(--color-text-secondary);
  font-weight: 600;
  font-size: 10px;
  flex-shrink: 0;
}

.landing-pdf-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
  align-items: flex-start;
}

.landing-pdf-name {
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  font-size: 12px;
  text-transform: none;
  font-weight: 500;
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  text-align: left;
}

.landing-pdf-size {
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  font-size: 10px;
  text-transform: none;
  font-weight: 400;
  color: var(--color-text-secondary);
  text-align: left;
}

.landing-pdf-remove {
  background: none;
  border: none;
  color: var(--color-text-secondary);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.15s ease, color 0.15s ease;
  flex-shrink: 0;
}

.landing-pdf-remove:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* ═══════════════════════════════════════════════════════════════
   Action Buttons
   ═══════════════════════════════════════════════════════════════ */

.landing-upload-panel::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 72px;
  background: linear-gradient(to bottom, transparent 0%, var(--color-bg-canvas-surface) 30%);
  pointer-events: none;
  z-index: 5;
}

.landing-upload-cta {
  position: absolute;
  bottom: 16px;
  right: 16px;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 24px;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background 0.15s ease;
  z-index: 10;
}

.landing-upload-cta:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.landing-upload-cta:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.landing-upload-cta-spinner {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  animation: landingCtaSpin 0.7s linear infinite;
}

@keyframes landingCtaSpin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.landing-bottom-actions {
  position: absolute;
  bottom: 16px;
  left: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 10;
}

.landing-attach-button {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
}

.landing-attach-button:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* ═══════════════════════════════════════════════════════════════
   Aspect Ratio Dropdown
   ═══════════════════════════════════════════════════════════════ */

.ar-trigger {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 11px;
  line-height: 1;
}

.ar-trigger:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.ar-trigger[data-state="open"] {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.ar-trigger-label {
  font-family: var(--font-mono, monospace);
  font-weight: 500;
  letter-spacing: -0.01em;
}

.ar-chevron {
  opacity: 0.5;
  flex-shrink: 0;
}

.ar-icon {
  flex-shrink: 0;
}

.ar-content {
  min-width: 140px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 100;
  animation: arFadeIn 0.12s ease;
}

@keyframes arFadeIn {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

.ar-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: 12px;
  outline: none;
  transition: background 0.1s ease, color 0.1s ease;
}

.ar-item:hover,
.ar-item[data-highlighted] {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.ar-item-selected {
  color: var(--color-text-primary);
}

.ar-item-label {
  font-family: var(--font-mono, monospace);
  font-weight: 500;
  flex: 1 1;
}

.ar-check {
  margin-left: auto;
  flex-shrink: 0;
  opacity: 0.7;
}

/* ═══════════════════════════════════════════════════════════════
   Composer Model Dropdown
   ═══════════════════════════════════════════════════════════════ */

.mt-trigger {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 11px;
  line-height: 1;
}

.mt-trigger:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.mt-trigger[data-state="open"] {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.mt-trigger-icon {
  flex-shrink: 0;
  opacity: 0.7;
}

.mt-trigger-label {
  font-weight: 500;
  letter-spacing: -0.01em;
}

.mt-content {
  min-width: 240px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 100;
  animation: arFadeIn 0.12s ease;
}

/* ─── Composer LLM selector ─── */

.llm-content {
  min-width: 220px;
}

.llm-group + .llm-group {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid var(--color-border-input);
}

.llm-provider {
  padding: 6px 8px 4px;
  color: var(--color-text-secondary);
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.65;
}

.llm-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 8px;
  border-radius: 5px;
  color: var(--color-text-secondary);
  cursor: pointer;
  font-size: 11px;
  outline: none;
}

.llm-item:hover,
.llm-item[data-highlighted],
.llm-item-selected {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.llm-check {
  flex-shrink: 0;
}

/* ═══════════════════════════════════════════════════════════════
   Keyboard Shortcut Hint
   ═══════════════════════════════════════════════════════════════ */

.landing-shortcut-hint {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 8px;
  font-size: 11px;
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.landing-shortcut-key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 16px;
  padding: 0 4px;
  border-radius: 3px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  font-size: 10px;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-weight: 500;
}

.landing-shortcut-key svg {
  width: 9px;
  height: 9px;
}

.landing-shortcut-plus {
  font-size: 10px;
  font-weight: 500;
  margin: 0 1px;
}

.landing-shortcut-text {
  margin-left: 3px;
  font-size: 11px;
}

/* ═══════════════════════════════════════════════════════════════
   Authenticated Home Templates
   ═══════════════════════════════════════════════════════════════ */

.landing-template-section {
  width: 100%;
  margin-top: 52px;
  text-align: left;
}

.landing-template-section__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 14px;
}

.landing-template-section__label {
  display: block;
  margin-bottom: 7px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.landing-template-section__title {
  margin: 0;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 30px;
  font-weight: 400;
  line-height: 1.12;
  color: var(--color-text-primary);
}

.landing-template-section__link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  color: var(--color-text-secondary);
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
  transition: color 0.15s ease;
}

.landing-template-section__link:hover {
  color: var(--color-text-primary);
}

.landing-template-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.landing-template-card {
  appearance: none;
  width: 100%;
  min-height: 138px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: start;
  gap: 14px;
  padding: 18px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  color: var(--color-text-primary);
  text-align: left;
  cursor: pointer;
  font: inherit;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.landing-template-card:hover {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
  transform: translateY(-1px);
}

.landing-template-card__icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-accent-base);
}

.landing-template-card--blue .landing-template-card__icon {
  color: #6f9ee8;
}

.landing-template-card--green .landing-template-card__icon {
  color: #5fbf92;
}

.landing-template-card--teal .landing-template-card__icon {
  color: #45b8c4;
}

.landing-template-card--yellow .landing-template-card__icon {
  color: #d6a84f;
}

.landing-template-card--red .landing-template-card__icon {
  color: #e47575;
}

.landing-template-card--pink .landing-template-card__icon {
  color: #de7fa6;
}

.landing-template-card--cyan .landing-template-card__icon {
  color: #56b6de;
}

.landing-template-card--lime .landing-template-card__icon {
  color: #93c66c;
}

.landing-template-card__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.landing-template-card__eyebrow {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.landing-template-card__title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  color: var(--color-text-primary);
}

.landing-template-card__desc {
  max-width: 44ch;
  font-size: 12px;
  line-height: 1.55;
  color: var(--color-text-secondary);
}

.landing-template-card__arrow {
  color: var(--color-text-secondary);
  opacity: 0.75;
  transition: transform 0.15s ease, color 0.15s ease;
}

.landing-template-card:hover .landing-template-card__arrow {
  color: var(--color-text-primary);
  transform: translateX(2px);
}

.landing-submit-confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 2200;
  background: color-mix(in srgb, var(--color-bg-root) 88%, transparent 12%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.landing-submit-confirm-modal {
  width: min(560px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 18px;
}

.landing-submit-confirm-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.landing-submit-confirm-text {
  margin: 0 0 14px 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--color-text-secondary);
}

.landing-submit-confirm-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.landing-submit-confirm-secondary,
.landing-submit-confirm-primary {
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.landing-submit-confirm-secondary {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

.landing-submit-confirm-primary {
  background: var(--color-text-primary);
  color: var(--color-bg-root);
}

.landing-submit-confirm-secondary:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.landing-submit-confirm-primary:hover:not(:disabled) {
  opacity: 0.88;
}

.landing-submit-confirm-secondary:disabled,
.landing-submit-confirm-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ═══════════════════════════════════════════════════════════════
   Auth State
   ═══════════════════════════════════════════════════════════════ */

.landing-auth-state {
  display: flex;
  align-items: center;
  gap: 10px;
}

.landing-auth-state span {
  font-size: 12px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.landing-auth-state button {
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  cursor: pointer;
  transition: background 0.15s ease;
}

.landing-auth-state button:hover {
  background: var(--color-bg-user-bubble);
}

/* ═══════════════════════════════════════════════════════════════
   Responsive
   ═══════════════════════════════════════════════════════════════ */

@media (max-width: 720px) {
  .landing-content.landing-authenticated .landing-main {
    padding: 32px 16px 44px;
  }

  .landing-main {
    gap: 24px;
  }

  .landing-title {
    margin-top: 6vh;
  }

  .landing-announcement-chip {
    font-size: 12px;
    padding: 8px 12px;
  }

  .landing-upload-panel {
    padding: 16px 20px 64px 20px;
  }

  .landing-submit-confirm-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .landing-upload-panel::after {
    height: 64px;
  }

  .landing-upload-cta {
    width: 40px;
    height: 40px;
    bottom: 14px;
    right: 14px;
  }

  .landing-bottom-actions {
    bottom: 14px;
    left: 14px;
  }

  .landing-attach-button {
    width: 30px;
    height: 30px;
  }

  .ar-trigger {
    height: 30px;
    padding: 0 6px;
    font-size: 10px;
  }

  .mt-trigger {
    height: 30px;
    padding: 0 6px;
    font-size: 10px;
  }

  .landing-template-section {
    margin-top: 38px;
  }

  .landing-template-section__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .landing-template-grid {
    grid-template-columns: 1fr;
  }

  .landing-template-card {
    min-height: 126px;
    padding: 16px;
  }
}

/* ═══════════════════════════════════════════════════════════════
   Drag Overlay
   ═══════════════════════════════════════════════════════════════ */

.landing-drag-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--color-bg-root);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.landing-drag-message {
  font-size: 24px;
  font-weight: 500;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'Times New Roman', serif;
  padding: 32px 48px;
  border: 1px dashed var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
}

/* ═══════════════════════════════════════════════════════════════
   Video Gallery Section
   ═══════════════════════════════════════════════════════════════ */

.gallery-section {
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  padding: 48px clamp(20px, 5vw, 48px) 80px;
  position: relative;
  z-index: 5;
  text-align: center;
}

.gallery-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 400;
  color: var(--color-text-primary);
  text-align: center;
  margin: 0 0 40px 0;
}

.gallery-title-brand {
  color: var(--color-text-primary);
  font-style: italic;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.gallery-card {
  border-radius: 10px;
  overflow: hidden;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.gallery-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.gallery-card-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
}

.gallery-card-title {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-primary);
}

.gallery-card-likes {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 12px;
  color: var(--color-text-secondary);
}

.gallery-item {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  aspect-ratio: 4 / 3;
  background: var(--color-bg-input);
}

.gallery-item:hover {
  opacity: 0.85;
}

.gallery-item-media {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.gallery-thumbnail {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.2s ease;
}

.gallery-thumbnail-hidden {
  opacity: 0;
}

.gallery-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.gallery-video-visible {
  opacity: 1;
}

.gallery-item-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.2) 40%,
    transparent 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 14px;
  pointer-events: none;
}

.gallery-item-title {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 0.01em;
}

.gallery-item-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.9);
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);
  opacity: 0;
  transition: opacity 0.15s ease, transform 0.15s ease;
  border: 1px solid var(--color-border-input);
}

.gallery-item:hover .gallery-item-play {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}

/* ═══════════════════════════════════════════════════════════════
   Video Modal
   ═══════════════════════════════════════════════════════════════ */

.video-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  animation: modalFadeIn 0.2s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.video-modal-container {
  position: relative;
  max-width: 900px;
  width: 100%;
  animation: modalSlideIn 0.25s ease;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.video-modal-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 32px;
  height: 32px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  border-radius: 4px;
  color: var(--color-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, color 0.15s ease;
}

.video-modal-close:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.video-modal-content {
  background: var(--color-bg-canvas-surface);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
}

.video-modal-player {
  width: 100%;
  aspect-ratio: 16 / 9;
  display: block;
  background: var(--color-bg-input);
}

.video-modal-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 18px;
  font-weight: 400;
  color: var(--color-text-primary);
  margin: 0;
  padding: 14px 20px;
  border-top: 1px solid var(--color-border-input);
}

/* ═══════════════════════════════════════════════════════════════
   Gallery Responsive
   ═══════════════════════════════════════════════════════════════ */

@media (max-width: 900px) {
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
}

@media (max-width: 600px) {
  .gallery-section {
    padding: 32px 20px 64px;
  }
  
  .gallery-title {
    margin-bottom: 24px;
  }
  
  .gallery-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .gallery-item {
    aspect-ratio: 16 / 10;
  }
  
  .video-modal-backdrop {
    padding: 20px;
  }
  
  .video-modal-close {
    top: -36px;
  }
  
  .video-modal-title {
    font-size: 16px;
    padding: 12px 16px;
  }
}

/* ═══════════════════════════════════════════════════════════════
   Footer Section
   ═══════════════════════════════════════════════════════════════ */

.landing-footer {
  background: var(--color-bg-canvas-surface);
  border-top: 1px solid var(--color-border-input);
  position: relative;
  z-index: 5;
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 48px clamp(20px, 5vw, 40px) 32px;
}

.footer-top {
  display: grid;
  grid-template-columns: 2fr repeat(4, 1fr);
  gap: 32px;
  padding-bottom: 40px;
  border-bottom: 1px solid var(--color-border-input);
}

.footer-brand {
  max-width: 240px;
}

.footer-logo-img {
  height: 40px;
  width: auto;
  margin: 0 0 12px 0;
  opacity: 0.8;
}

.footer-tagline {
  font-size: 13px;
  line-height: 1.5;
  color: var(--color-text-secondary);
  margin: 0 0 16px 0;
}

.footer-social {
  display: flex;
  gap: 8px;
}

.footer-social-link {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  transition: all 0.15s ease;
}

.footer-social-link:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.footer-links-group {
  min-width: 0;
}

.footer-links-title {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-secondary);
  margin: 0 0 14px 0;
}

.footer-links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-links li a {
  font-size: 13px;
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color 0.15s ease;
}

.footer-links li a:hover {
  color: var(--color-text-primary);
}

/* Newsletter section */
.footer-newsletter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: 32px 0;
  border-bottom: 1px solid var(--color-border-input);
}

.footer-newsletter-content {
  flex: 1 1;
}

.footer-newsletter-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 18px;
  font-weight: 400;
  color: var(--color-text-primary);
  margin: 0 0 4px 0;
}

.footer-newsletter-desc {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0;
}

.footer-newsletter-form {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.footer-newsletter-input {
  width: 240px;
  padding: 10px 14px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  font-size: 13px;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  color: var(--color-text-primary);
  outline: none;
  transition: border-color 0.15s ease;
}

.footer-newsletter-input::placeholder {
  color: var(--color-text-secondary);
}

.footer-newsletter-input:focus {
  border-color: var(--color-text-secondary);
}

.footer-newsletter-btn {
  padding: 10px 20px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.footer-newsletter-btn:hover {
  background: var(--color-bg-user-bubble);
}

/* Footer bottom */
.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 24px;
}

.footer-copyright {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin: 0;
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  gap: 6px;
}

.footer-bottom-links a {
  font-size: 12px;
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color 0.15s ease;
}

.footer-bottom-links a:hover {
  color: var(--color-text-primary);
}

.footer-dot {
  color: var(--color-text-secondary);
  font-size: 10px;
  opacity: 0.5;
}

/* Footer Responsive */
@media (max-width: 1024px) {
  .footer-top {
    grid-template-columns: 1fr 1fr;
    gap: 28px;
  }
  
  .footer-brand {
    grid-column: span 2;
    max-width: 100%;
  }
  
  .footer-social {
    margin-bottom: 16px;
  }
}

@media (max-width: 768px) {
  .footer-inner {
    padding: 40px 20px 24px;
  }
  
  .footer-top {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
  
  .footer-newsletter {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .footer-newsletter-form {
    width: 100%;
  }
  
  .footer-newsletter-input {
    flex: 1 1;
    width: auto;
    min-width: 0;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .footer-top {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .footer-brand {
    grid-column: span 1;
  }
  
  .footer-newsletter-form {
    flex-direction: column;
  }
  
  .footer-newsletter-btn {
    width: 100%;
  }
}

/* ═══════════════════════════════════════════════════════════════
   Features Section - Killer Features Showcase
   ═══════════════════════════════════════════════════════════════ */

.ft-section-label {
  display: inline-block;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-accent-base);
  margin-bottom: 16px;
  padding: 5px 12px;
  border: 1px solid var(--color-accent-base);
  border-radius: 3px;
  opacity: 0.85;
}

/* ─── Composer Section ─── */

.composer-section {
  max-width: 1100px;
  margin: 0 auto;
  padding: 80px clamp(20px, 5vw, 48px);
  position: relative;
  z-index: 5;
}

.composer-inner {
  opacity: 0;
  transform: translateY(32px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.composer-inner--visible {
  opacity: 1;
  transform: translateY(0);
}

.composer-header {
  text-align: center;
  margin-bottom: 48px;
}

.composer-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 400;
  line-height: 1.15;
  color: var(--color-text-primary);
  margin: 0;
}

.composer-title-em {
  font-style: italic;
  color: var(--color-accent-base);
}

.composer-content {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 48px;
  align-items: center;
}

.composer-animation {
  position: relative;
  aspect-ratio: 4 / 3;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  overflow: hidden;
}

.composer-anim-step {
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: scale(0.97) translateY(8px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  will-change: opacity, transform;
}

.composer-anim-step--active {
  opacity: 1;
  transform: scale(1) translateY(0);
}

.composer-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.composer-step {
  all: unset;
  display: flex;
  gap: 16px;
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
  opacity: 0.4;
  transform: translateX(0);
  transition: opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1),
              background 0.5s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  align-items: flex-start;
  text-align: left;
}

.composer-step--active {
  opacity: 1;
  background: var(--color-bg-canvas-surface);
  transform: translateX(4px);
}

.composer-step:hover {
  opacity: 0.7;
}

.composer-step--active:hover {
  opacity: 1;
}

.composer-step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  border: 1px solid var(--color-border-input);
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 16px;
  color: var(--color-text-primary);
  margin-top: 2px;
}

.composer-step--active .composer-step-number {
  background: var(--color-accent-base);
  border-color: var(--color-accent-base);
  color: #fff;
}

.composer-step-text {
  flex: 1 1;
}

.composer-step-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 20px;
  font-weight: 400;
  color: var(--color-text-primary);
  margin: 0 0 6px;
  line-height: 1.2;
}

.composer-step-desc {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  line-height: 1.6;
  color: var(--color-text-secondary);
  margin: 0;
}

/* ─── Composer Animation Internals ─── */

/* Step 1: Prompt */
.canim-prompt {
  width: 100%;
  padding: 8px;
}

.canim-prompt-box {
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  overflow: hidden;
}

.canim-prompt-header {
  display: flex;
  gap: 5px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-border-input);
}

.canim-prompt-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-text-secondary);
  opacity: 0.25;
}

.canim-prompt-body {
  padding: 16px;
  min-height: 80px;
}

.canim-prompt-text {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  line-height: 1.6;
  color: var(--color-text-primary);
  display: inline;
}

.canim-prompt-cursor {
  display: inline-block;
  width: 2px;
  height: 1em;
  background: var(--color-accent-base);
  vertical-align: text-bottom;
  margin-left: 1px;
  animation: composerBlink 0.7s step-end infinite;
}

.canim-prompt-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-top: 1px solid var(--color-border-input);
}

.canim-prompt-attach {
  color: var(--color-text-secondary);
  opacity: 0.5;
}

.canim-prompt-send {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 14px;
  transition: background 0.3s ease, color 0.3s ease;
}

.canim-prompt-send--active {
  background: var(--color-accent-base);
  color: #fff;
  transition-delay: 2.8s;
}


@keyframes composerBlink {
  50% { border-color: transparent; }
}

/* Step 2: Editor */
.canim-editor {
  width: 100%;
  padding: 8px;
}

.canim-editor-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.canim-editor-status--visible {
  opacity: 1;
  transition-delay: 0.2s;
}

.canim-editor-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid var(--color-border-input);
  border-top-color: var(--color-accent-base);
  border-radius: 50%;
  animation: composerSpin 0.7s linear infinite;
  flex-shrink: 0;
}

.canim-editor-status-text {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: var(--color-accent-base);
}

@keyframes composerSpin {
  to { transform: rotate(360deg); }
}

.canim-editor-toolbar {
  display: flex;
  gap: 6px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-border-input);
  background: var(--color-bg-root);
  border-radius: 8px 8px 0 0;
  border: 1px solid var(--color-border-input);
  border-bottom: none;
}

.canim-editor-toolbar-item {
  width: 24px;
  height: 8px;
  border-radius: 2px;
  background: var(--color-text-secondary);
  opacity: 0.15;
}

.canim-editor-toolbar-spacer {
  flex: 1 1;
  background: none;
}

.canim-editor-toolbar-item--wide {
  width: 48px;
}

.canim-editor-tracks {
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 0 0 8px 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.canim-editor-track {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
}

.canim-editor-track-label {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: var(--color-text-secondary);
  opacity: 0.5;
  width: 16px;
  text-align: center;
  flex-shrink: 0;
}

.canim-editor-clip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  opacity: 0;
  transform: translateX(-20px);
}

.canim-editor-clip--in {
  animation: composerSlideIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.canim-editor-clip--v1.canim-editor-clip--in { animation-delay: 0.3s; }
.canim-editor-clip--v2.canim-editor-clip--in { animation-delay: 0.7s; }
.canim-editor-clip--v3.canim-editor-clip--in { animation-delay: 1.1s; }
.canim-editor-clip--audio.canim-editor-clip--in { animation-delay: 1.5s; }

.canim-editor-clip-thumb {
  width: 24px;
  height: 16px;
  border-radius: 2px;
  background: var(--color-accent-base);
  opacity: 0.4;
  flex-shrink: 0;
}

.canim-editor-clip--audio .canim-editor-clip-thumb {
  display: none;
}

.canim-editor-clip-wave {
  width: 60px;
  height: 12px;
  border-radius: 2px;
  background: repeating-linear-gradient(
    90deg,
    var(--color-accent-base) 0px,
    var(--color-accent-base) 2px,
    transparent 2px,
    transparent 4px
  );
  opacity: 0.3;
  flex-shrink: 0;
}

.canim-editor-clip-name {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 10px;
  color: var(--color-text-secondary);
  white-space: nowrap;
}

@keyframes composerSlideIn {
  from { transform: translateX(-20px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

/* Step 3: Export */

.canim-export-timeline {
  width: 100%;
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 12px;
}

.canim-export-track {
  display: flex;
  gap: 6px;
}

.canim-export-clip {
  flex: 1 1;
  height: 40px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: flex 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.canim-export-clip--trimmed {
  flex: 0.6 1;
}

.canim-export-clip-inner {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 10px;
  color: var(--color-text-secondary);
}

.canim-export-cursor {
  position: absolute;
  color: var(--color-text-primary);
  opacity: 0;
  top: 28px;
  left: 42%;
  transition: opacity 0.3s ease, top 0.6s cubic-bezier(0.16, 1, 0.3, 1), left 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  pointer-events: none;
  z-index: 2;
}

.canim-export-cursor--visible {
  opacity: 1;
}

.canim-export-cursor--at-clip {
  top: 28px;
  left: 42%;
}

.canim-export-cursor--trimming {
  top: 32px;
  left: 32%;
}

.canim-export-cursor--at-btn {
  top: 96px;
  left: 48%;
}

.canim-export {
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  position: relative;
}

.canim-export-btn {
  all: unset;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 6px;
  background: var(--color-accent-base);
  color: #fff;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.canim-export-btn--visible {
  opacity: 1;
  transform: scale(1);
}

.canim-export-btn--clicked {
  animation: composerButtonPulse 0.3s ease;
}

@keyframes composerButtonPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(0.92); }
}

/* ─── Numbers Section ─── */

.numbers-section {
  padding: 80px clamp(20px, 5vw, 48px);
  position: relative;
  z-index: 5;
}

.numbers-inner {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.numbers-inner--visible {
  opacity: 1;
  transform: translateY(0);
}

.numbers-card {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  padding: 40px 32px;
  text-align: center;
  opacity: 0;
  transform: translateY(16px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.numbers-card--visible {
  opacity: 1;
  transform: translateY(0);
}

.numbers-value {
  display: block;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(36px, 5vw, 56px);
  font-weight: 400;
  color: var(--color-text-primary);
  line-height: 1;
  margin-bottom: 12px;
}

.numbers-label {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.4;
}

/* ─── Get Started Section ─── */

.ft-get-started {
  padding: 68px clamp(20px, 5vw, 48px) 86px;
  background: var(--color-bg-canvas-surface);
  border-top: 1px solid var(--color-border-input);
}

.ft-get-started__inner {
  max-width: 1120px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.25fr);
  align-items: center;
  gap: 30px;
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.ft-get-started__inner--visible {
  opacity: 1;
  transform: translateY(0);
}

.ft-get-started__content {
  text-align: left;
}

.ft-get-started__title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(28px, 3.6vw, 46px);
  font-weight: 400;
  line-height: 1.08;
  letter-spacing: -0.01em;
  color: var(--color-text-primary);
  margin: 0 0 16px;
}

.ft-get-started__desc {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 14px;
  line-height: 1.7;
  color: var(--color-text-secondary);
  max-width: 460px;
  margin: 0 0 28px;
}

.ft-get-started__cta {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--color-border-input);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  border-radius: 4px;
  padding: 12px 16px;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}

.ft-get-started__cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px -12px rgba(15, 18, 24, 0.45);
}

.ft-get-started__cta:active {
  transform: translateY(0);
}

.ft-get-started__cta-arrow {
  font-size: 14px;
  transition: transform 0.18s ease;
}

.ft-get-started__cta:hover .ft-get-started__cta-arrow {
  transform: translateX(2px);
}

.ft-get-started__preview {
  position: relative;
}

.ft-get-started__preview::before {
  content: "";
  position: absolute;
  inset: -10px -10px auto auto;
  width: 72%;
  height: 62%;
  background: radial-gradient(
    circle at top right,
    color-mix(in srgb, var(--color-accent-base) 30%, transparent),
    transparent 70%
  );
  pointer-events: none;
  z-index: 0;
  opacity: 0.45;
}

.ft-get-started__frame {
  position: relative;
  z-index: 1;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  box-shadow: 0 20px 46px -28px rgba(15, 18, 24, 0.55);
}

.ft-get-started__frame-top {
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  border-bottom: 1px solid var(--color-border-input);
  background: color-mix(in srgb, var(--color-bg-root) 55%, var(--color-bg-canvas-surface));
}

.ft-get-started__dots {
  display: inline-flex;
  gap: 6px;
}

.ft-get-started__dots span {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--color-border-input);
}

.ft-get-started__frame-label {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.ft-get-started__image {
  width: 100%;
  height: auto;
  display: block;
}

.ft-get-started__chip {
  position: absolute;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border-radius: 999px;
  border: 1px solid var(--color-border-input);
  background: color-mix(in srgb, var(--color-bg-canvas-surface) 86%, transparent);
  backdrop-filter: blur(3px);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-primary);
  white-space: nowrap;
  animation: ftChipFloat 4.4s ease-in-out infinite;
}

.ft-get-started__chip::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--color-accent-base);
  opacity: 0.9;
}

.ft-get-started__chip--one {
  left: -14px;
  top: 52px;
}

.ft-get-started__chip--two {
  right: -12px;
  top: 110px;
  animation-delay: 0.5s;
}

.ft-get-started__chip--three {
  left: 30px;
  bottom: 18px;
  animation-delay: 1s;
}

@keyframes ftChipFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}

/* ─── Automation Section ─── */

.automation-section {
  max-width: 1100px;
  margin: 0 auto;
  padding: 80px clamp(20px, 5vw, 48px);
  position: relative;
  z-index: 5;
}

.automation-inner {
  opacity: 0;
  transform: translateY(32px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.automation-inner--visible {
  opacity: 1;
  transform: translateY(0);
}

.automation-header {
  text-align: center;
  margin-bottom: 48px;
}

.automation-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 400;
  line-height: 1.15;
  color: var(--color-text-primary);
  margin: 0;
}

.automation-title-em {
  font-style: italic;
  color: var(--color-accent-base);
}

.automation-subtitle {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: var(--color-text-secondary);
  margin: 12px auto 0;
  max-width: 520px;
}

.automation-content {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 48px;
  align-items: center;
}

.automation-animation {
  position: relative;
  aspect-ratio: 4 / 3;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  overflow: hidden;
}

/* ─── Automation Anim: Ideate ─── */

.aauto-ideate {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px;
}

.aauto-ideate-product,
.aauto-ideate-persona {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  opacity: 0;
  transform: translateY(12px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.aauto-ideate-product--in,
.aauto-ideate-persona--in {
  opacity: 1;
  transform: translateY(0);
}

.aauto-ideate-product-img,
.aauto-ideate-persona-avatar {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: var(--color-bg-canvas-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
}

.aauto-ideate-product-label,
.aauto-ideate-persona-label {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 11px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.aauto-ideate-plus {
  font-size: 20px;
  color: var(--color-text-secondary);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.aauto-ideate-plus--in {
  opacity: 0.5;
}

.aauto-ideate-arrow {
  opacity: 0;
  transform: translateX(-8px);
  transition: opacity 0.4s ease, transform 0.4s ease;
  color: var(--color-text-secondary);
  flex-basis: 100%;
  display: flex;
  justify-content: center;
}

.aauto-ideate-arrow--in {
  opacity: 0.5;
  transform: translateX(0);
}

.aauto-ideate-ideas {
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  padding: 12px 16px;
  min-width: 220px;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.aauto-ideate-ideas--in {
  opacity: 1;
  transform: translateY(0);
}

.aauto-ideate-ideas-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--color-border-input);
}

.aauto-ideate-idea {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 11px;
  color: var(--color-text-secondary);
  padding: 5px 0;
  opacity: 0;
  transform: translateX(-8px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.aauto-ideate-idea--in {
  opacity: 1;
  transform: translateX(0);
}

.aauto-ideate-idea-dot {
  width: 5px;
  height: 5px;
  min-width: 5px;
  border-radius: 50%;
  background: var(--color-accent-base);
}

/* ─── Automation Anim: Generate ─── */

.aauto-generate {
  width: 100%;
  padding: 16px;
}

.aauto-generate-composer {
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  overflow: hidden;
}

.aauto-generate-composer--in {
  opacity: 1;
}

.aauto-generate-composer-header {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--color-border-input);
}

.aauto-generate-composer-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-text-secondary);
  opacity: 0.25;
}

.aauto-generate-composer-title {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 11px;
  color: var(--color-text-secondary);
  margin-left: 8px;
  font-weight: 500;
}

.aauto-generate-preview {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 16px;
}

.aauto-generate-frame {
  aspect-ratio: 9 / 16;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.aauto-generate-frame--in {
  opacity: 1;
  transform: scale(1);
}

.aauto-generate-frame--1 { transition-delay: 0ms; }
.aauto-generate-frame--2 { transition-delay: 200ms; }
.aauto-generate-frame--3 { transition-delay: 400ms; }

.aauto-generate-frame-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    110deg,
    transparent 30%,
    var(--color-accent-base-transparent, rgba(99, 102, 241, 0.06)) 50%,
    transparent 70%
  );
  background-size: 200% 100%;
  animation: aautoShimmer 2s ease-in-out infinite;
}

@keyframes aautoShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.aauto-generate-frame-icon {
  color: var(--color-text-secondary);
  opacity: 0.3;
  z-index: 1;
}

.aauto-generate-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 11px;
  color: var(--color-accent-base);
  font-weight: 500;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.aauto-generate-status--in {
  opacity: 1;
}

.aauto-generate-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid var(--color-border-input);
  border-top-color: var(--color-accent-base);
  border-radius: 50%;
  animation: aautoSpin 0.8s linear infinite;
}

@keyframes aautoSpin {
  to { transform: rotate(360deg); }
}

.aauto-generate-bar {
  height: 3px;
  margin: 10px 16px 14px;
  background: var(--color-bg-canvas-surface);
  border-radius: 2px;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.aauto-generate-bar--in {
  opacity: 1;
}

.aauto-generate-bar-fill {
  height: 100%;
  width: 0%;
  background: var(--color-accent-base);
  border-radius: 2px;
  transition: width 1.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.aauto-generate-bar-fill--mid {
  width: 60%;
}

.aauto-generate-bar-fill--done {
  width: 100%;
}

/* ─── Automation Anim: Publish ─── */

.aauto-publish {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 16px;
  position: relative;
}

.aauto-publish-source {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  opacity: 0;
  transform: translateY(-8px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.aauto-publish-source--in {
  opacity: 1;
  transform: translateY(0);
}

.aauto-publish-thumb {
  width: 36px;
  height: 36px;
  background: var(--color-bg-canvas-surface);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
}

.aauto-publish-source-label {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 12px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.aauto-publish-arrows {
  display: flex;
  gap: 24px;
  justify-content: center;
  height: 20px;
}

.aauto-publish-arrow {
  width: 2px;
  height: 0;
  background: var(--color-accent-base);
  opacity: 0.4;
  border-radius: 1px;
  transition: height 0.5s ease;
}

.aauto-publish-arrow--in {
  height: 20px;
}

.aauto-publish-arrow--1 { transition-delay: 0ms; }
.aauto-publish-arrow--2 { transition-delay: 100ms; }
.aauto-publish-arrow--3 { transition-delay: 200ms; }

.aauto-publish-platforms {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.aauto-publish-platform {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-primary);
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.aauto-publish-platform--in {
  opacity: 1;
  transform: translateY(0);
}

.aauto-publish-platform svg {
  color: var(--color-text-secondary);
}

.aauto-publish-check {
  color: #22c55e;
  font-weight: 700;
  opacity: 0;
  transform: scale(0);
  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.aauto-publish-check--in {
  opacity: 1;
  transform: scale(1);
}

.aauto-publish-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: var(--color-accent-base);
  color: #fff;
  border-radius: 20px;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.aauto-publish-badge--in {
  opacity: 1;
  transform: translateY(0);
}

/* ─── Automation Anim: Repeat & Scale ─── */

.aauto-repeat {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 16px;
}

/* Schedule badge */
.aauto-repeat-schedule {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  background: var(--color-accent-base);
  color: #fff;
  border-radius: 20px;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  opacity: 0;
  transform: translateY(-8px);
  transition: opacity 0.45s ease, transform 0.45s ease;
}

.aauto-repeat-schedule--in {
  opacity: 1;
  transform: translateY(0);
}

/* Pipeline row */
.aauto-repeat-pipeline {
  display: flex;
  align-items: center;
  gap: 0;
}

.aauto-repeat-pipe-step {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: var(--color-text-primary);
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.aauto-repeat-pipe-step--in {
  opacity: 1;
  transform: translateY(0);
}

.aauto-repeat-pipe-icon {
  display: flex;
  color: var(--color-accent-base);
}

.aauto-repeat-pipe-arrow {
  margin: 0 2px 0 8px;
  font-size: 16px;
  color: var(--color-text-secondary);
  opacity: 0.4;
}

.aauto-repeat-pipe-label {
  white-space: nowrap;
}

/* Loop-back bar */
.aauto-repeat-loopback {
  position: relative;
  width: 85%;
  height: 24px;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.aauto-repeat-loopback--in {
  opacity: 1;
}

.aauto-repeat-loopback--in .aauto-repeat-loopback-path {
  animation: aautoLoopDash 1.8s linear infinite;
}

@keyframes aautoLoopDash {
  to { stroke-dashoffset: -28; }
}

.aauto-repeat-loopback-label {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-accent-base);
  background: var(--color-bg-canvas-surface);
  padding: 0 8px;
}

/* Scaling accounts */
.aauto-repeat-accounts {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.aauto-repeat-accounts--in {
  opacity: 1;
  transform: translateY(0);
}

.aauto-repeat-account {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.aauto-repeat-accounts--in .aauto-repeat-account {
  opacity: 1;
  transform: scale(1);
}

.aauto-repeat-account--in {
  opacity: 1;
  transform: scale(1);
}

.aauto-repeat-account--add {
  border-style: dashed;
  cursor: pointer;
}

.aauto-repeat-account-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--color-accent-base);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 10px;
  font-weight: 700;
}

.aauto-repeat-account-name {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: var(--color-text-primary);
}

.aauto-repeat-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
}

.aauto-repeat-account-plus {
  font-size: 16px;
  color: var(--color-text-secondary);
  line-height: 1;
}

/* ─── Sections Responsive ─── */

@media (max-width: 900px) {
  .composer-content,
  .automation-content {
    grid-template-columns: 1fr;
  }

  .ft-get-started__inner {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .ft-get-started__content {
    text-align: center;
  }

  .ft-get-started__desc {
    margin-left: auto;
    margin-right: auto;
  }

  .ft-get-started__chip--one {
    left: 10px;
  }

  .ft-get-started__chip--two {
    right: 10px;
  }
}

@media (max-width: 600px) {
  .composer-section,
  .automation-section {
    padding: 60px 20px;
  }

  .composer-animation,
  .automation-animation {
    aspect-ratio: 16 / 10;
  }

  .numbers-inner {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .numbers-card {
    padding: 28px 24px;
  }

  .ft-get-started {
    padding: 46px 20px 60px;
  }

  .ft-get-started__title {
    font-size: clamp(26px, 9vw, 38px);
  }

  .ft-get-started__cta {
    width: 100%;
    justify-content: center;
  }

  .ft-get-started__chip {
    position: static;
    margin-top: 8px;
    margin-right: 6px;
  }

  .ft-get-started__chip--one,
  .ft-get-started__chip--two,
  .ft-get-started__chip--three {
    left: auto;
    right: auto;
    top: auto;
    bottom: auto;
  }

  .ft-get-started__preview {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0;
  }

  .ft-get-started__frame {
    width: 100%;
  }
}

/* ─── Landing showcase (compact single row from ExamplesPage) ─── */

.landing-showcase {
  padding: 48px 0 80px;
}

.landing-showcase-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 48px);
  gap: 0;
}

.landing-showcase .ex-category-head .ft-section-label {
  display: inline-block;
  margin-bottom: 8px;
}

.landing-showcase .ex-category-head {
  margin-bottom: -20px;
  align-items: center;
}

.landing-showcase .ex-scroller-track {
  padding-top: 0;
}

.landing-showcase .ex-scroller::before,
.landing-showcase .ex-scroller::after {
  top: 0;
}

.landing-showcase-cta {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}
`, "",{"version":3,"sources":["webpack://./src/LandingPage.css"],"names":[],"mappings":"AAAA;;;wCAGwC;;AAIxC;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8EAA8E;EAC9E,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA,8EAA8E;AAC9E;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;oEAEoE;;AAEpE;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,4BAA4B;EAC5B,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,eAAe;EACf,gCAAgC;EAChC,8EAA8E;EAC9E,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA,qDAAqD;AACrD;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,8EAA8E;EAC9E,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8EAA8E;EAC9E,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;oEAEoE;;AAEpE;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,0FAA0F;EAC1F,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,iDAAiD;AACnD;;AAEA;;EAEE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,8BAA8B;AAChC;;AAEA,kCAAkC;;AAElC;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;;;EAGE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,kEAAkE;EAClE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;oEAEoE;;AAEpE;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,yEAAyE;EACzE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;EAEE,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;oEAEoE;;AAEpE;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;;oEAEoE;;AAEpE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mDAAmD;EACnD,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;oEAEoE;;AAEpE;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gDAAgD;EAChD,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,UAAU;EACV,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;oEAEoE;;AAEpE;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;;oEAEoE;;AAEpE;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;;oEAEoE;;AAEpE;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,eAAe;EACf,kEAAkE;EAClE,gCAAgC;EAChC,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;oEAEoE;;AAEpE;EACE,qBAAqB;EACrB,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;AACf;;AAEA,6BAA6B;;AAE7B;EACE,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B;0DACwD;AAC1D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,sCAAsC;EACtC;0DACwD;EACxD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB;;0DAEwD;EACxD,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mDAAmD;EACnD,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;AACX;;AAEA,yCAAyC;;AAEzC,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,sBAAsB;AACxB;;;AAGA;EACE,MAAM,yBAAyB,EAAE;AACnC;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,0CAA0C;EAC1C,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,kDAAkD;EAClD,gCAAgC;EAChC,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,sEAAsE;AACxE;;AAEA,+CAA+C,qBAAqB,EAAE;AACtE,+CAA+C,qBAAqB,EAAE;AACtE,+CAA+C,qBAAqB,EAAE;AACtE,kDAAkD,qBAAqB,EAAE;;AAEzE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;;;;GAMC;EACD,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,mBAAmB;;AAEnB;EACE,WAAW;EACX,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,WAAS;AACX;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;EACV,SAAS;EACT,SAAS;EACT,8GAA8G;EAC9G,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA,4BAA4B;;AAE5B;EACE,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B;0DACwD;AAC1D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,gCAAgC;;AAEhC;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B;0DACwD;AAC1D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;EACV,WAAW;EACX;;;;GAIC;EACD,oBAAoB;EACpB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kDAAkD;EAClD,wFAAwF;AAC1F;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,+EAA+E;EAC/E,0BAA0B;EAC1B,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,+BAA+B;;AAE/B;EACE,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B;0DACwD;AAC1D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oCAAoC;;AAEpC;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;;EAEE,gDAAgD;EAChD,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;EAClD,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gDAAgD;EAChD,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,sCAAsC;;AAEtC;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,uBAAuB,EAAE;AACpD,2BAA2B,uBAAuB,EAAE;;AAEpD;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,0CAA0C;EAC1C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,qCAAqC;;AAErC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,uBAAuB,EAAE;AACnD,0BAA0B,uBAAuB,EAAE;;AAEnD;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,+EAA+E;AACjF;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,WAAW;EACX,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,4CAA4C;;AAE5C;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,WAAW;EACX,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,UAAU;EACV,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,KAAK,sBAAsB,EAAE;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gDAAgD;EAChD,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA,gCAAgC;;AAEhC;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;;;IAGE,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,MAAM;EACR;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,oEAAoE;;AAEpE;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,MAAM;AACR;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["/* ===================================\n   Landing Page - Flat Design System\n   Uses CSS variables from colors.css\n   =================================== */\n\n@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap');\n\n* {\n  box-sizing: border-box;\n}\n\n.landing-content {\n  min-height: 100%;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  width: 100%;\n}\n\n.landing-content.landing-authenticated {\n  min-height: 100vh;\n  display: block;\n  overflow-y: auto;\n}\n\n.landing-gradient {\n  display: none;\n}\n\n.landing-main {\n  max-width: 720px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 18vh clamp(20px, 5vw, 32px) 60px;\n  text-align: center;\n  position: relative;\n  z-index: 5;\n  min-height: 70vh;\n  min-height: 70dvh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.landing-main > *,\n.landing-hero > * {\n  width: 100%;\n}\n\n.landing-main > .landing-announcement-chip,\n.landing-hero > .landing-announcement-chip {\n  width: auto;\n}\n\n/* Hero wrapper is layout-transparent by default (logged-out view unchanged) */\n.landing-hero {\n  display: contents;\n}\n\n.landing-content.landing-authenticated .landing-main {\n  max-width: 980px;\n  min-height: 100vh;\n  min-height: 100dvh;\n  padding: 48px clamp(20px, 5vw, 32px);\n  justify-content: center;\n}\n\n.landing-content.landing-authenticated .landing-title {\n  margin-bottom: 28px;\n}\n\n/* Center the authenticated composer within the available viewport. */\n.landing-content.landing-authenticated .landing-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.landing-content.landing-authenticated .landing-hero > form,\n.landing-content.landing-authenticated .landing-hero > .landing-shortcut-hint {\n  width: 100%;\n  max-width: 720px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.landing-content.landing-authenticated .landing-template-section {\n  margin-top: 24px;\n}\n\n.landing-content.landing-authenticated .landing-template-section {\n  text-align: center;\n}\n\n.landing-content.landing-authenticated .landing-template-section__header {\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.landing-content.landing-authenticated .landing-template-grid {\n  max-width: 720px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.landing-title {\n  margin: 0 0 clamp(24px, 5vh, 40px) 0;\n  font-size: clamp(36px, 4.5vw, 52px);\n  font-weight: 400;\n  line-height: 1.1;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.landing-title-em {\n  font-style: italic;\n}\n\n.landing-announcement-chip {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  margin: 0 0 16px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 999px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  line-height: 1.3;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.landing-announcement-chip:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.landing-announcement-chip:focus-visible {\n  outline: 2px solid var(--color-text-primary);\n  outline-offset: 2px;\n}\n\n.landing-announcement-chip strong {\n  font-weight: 700;\n}\n\n.landing-announcement-emoji {\n  line-height: 1;\n  transform: translateY(-1px);\n}\n\n.landing-announcement-arrow {\n  display: inline-flex;\n  line-height: 1;\n  transform: translateX(0);\n  transition: transform 0.2s ease;\n}\n\n.landing-announcement-chip:hover .landing-announcement-arrow,\n.landing-announcement-chip:focus-visible .landing-announcement-arrow {\n  transform: translateX(4px);\n}\n\n.landing-typewriter {\n  display: inline-block;\n  min-width: 0.5ch;\n}\n\n.landing-cursor {\n  display: inline-block;\n  animation: blink 1s step-end infinite;\n  margin-right: 0px;\n  color: var(--color-text-secondary);\n}\n\n@keyframes blink {\n  0%, 50% {\n    opacity: 1;\n  }\n  51%, 100% {\n    opacity: 0;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Upload Panel - Flat Design\n   ═══════════════════════════════════════════════════════════════ */\n\n.landing-upload-panel {\n  background: var(--color-bg-canvas-surface);\n  border-radius: 6px;\n  padding: 20px 24px 72px 24px;\n  border: 1px solid var(--color-border-input);\n  position: relative;\n  min-height: 160px;\n}\n\n.landing-upload-input {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: transparent;\n  border: none;\n  outline: none;\n  resize: none;\n  line-height: 1.6;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.landing-upload-input::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.landing-upload-placeholder {\n  margin: 0;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Attachments\n   ═══════════════════════════════════════════════════════════════ */\n\n.landing-attachments-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 16px;\n  margin-bottom: -16px;\n  margin-left: -16px;\n  align-items: flex-end;\n}\n\n.landing-reference-chips {\n  display: contents;\n}\n\n.landing-reference-menu {\n  left: 16px;\n  width: min(340px, calc(100vw - 40px));\n}\n\n/* ── Asset image chip (inside attachments grid) ── */\n.landing-asset-chip {\n  padding: 4px 8px 4px 4px;\n}\n\n.landing-asset-chip-thumb {\n  width: 36px;\n  height: 36px;\n  object-fit: cover;\n  border-radius: 3px;\n  flex-shrink: 0;\n  display: block;\n}\n\n/* ── @mention dropdown ── */\n.landing-mention-dropdown {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 0;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  width: 280px;\n  max-height: 240px;\n  overflow-y: auto;\n  z-index: 200;\n}\n\n.landing-mention-dropdown-label {\n  padding: 6px 10px 4px;\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.landing-mention-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  cursor: pointer;\n  transition: background 0.1s ease;\n}\n\n.landing-mention-item:hover,\n.landing-mention-item--selected {\n  background: var(--color-bg-input);\n}\n\n.landing-mention-thumb {\n  width: 34px;\n  height: 34px;\n  border-radius: 3px;\n  object-fit: cover;\n  flex-shrink: 0;\n  background: var(--color-bg-input);\n}\n\n.landing-mention-thumb-empty {\n  width: 34px;\n  height: 34px;\n  border-radius: 3px;\n  background: var(--color-bg-input);\n  flex-shrink: 0;\n}\n\n.landing-mention-item-text {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.landing-mention-item-name {\n  font-size: 13px;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n}\n\n.landing-mention-item-sub {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n}\n\n.landing-pdf-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  font-size: 11px;\n  position: relative;\n}\n\n.landing-pdf-extension {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-secondary);\n  font-weight: 600;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.landing-pdf-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n  align-items: flex-start;\n}\n\n.landing-pdf-name {\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  font-size: 12px;\n  text-transform: none;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 160px;\n  text-align: left;\n}\n\n.landing-pdf-size {\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  font-size: 10px;\n  text-transform: none;\n  font-weight: 400;\n  color: var(--color-text-secondary);\n  text-align: left;\n}\n\n.landing-pdf-remove {\n  background: none;\n  border: none;\n  color: var(--color-text-secondary);\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background 0.15s ease, color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.landing-pdf-remove:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Action Buttons\n   ═══════════════════════════════════════════════════════════════ */\n\n.landing-upload-panel::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 72px;\n  background: linear-gradient(to bottom, transparent 0%, var(--color-bg-canvas-surface) 30%);\n  pointer-events: none;\n  z-index: 5;\n}\n\n.landing-upload-cta {\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  width: 44px;\n  height: 44px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 24px;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  z-index: 10;\n}\n\n.landing-upload-cta:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.landing-upload-cta:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.landing-upload-cta-spinner {\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  animation: landingCtaSpin 0.7s linear infinite;\n}\n\n@keyframes landingCtaSpin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.landing-bottom-actions {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  z-index: 10;\n}\n\n.landing-attach-button {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.landing-attach-button:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Aspect Ratio Dropdown\n   ═══════════════════════════════════════════════════════════════ */\n\n.ar-trigger {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  height: 32px;\n  padding: 0 8px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.ar-trigger:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.ar-trigger[data-state=\"open\"] {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.ar-trigger-label {\n  font-family: var(--font-mono, monospace);\n  font-weight: 500;\n  letter-spacing: -0.01em;\n}\n\n.ar-chevron {\n  opacity: 0.5;\n  flex-shrink: 0;\n}\n\n.ar-icon {\n  flex-shrink: 0;\n}\n\n.ar-content {\n  min-width: 140px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 4px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n  animation: arFadeIn 0.12s ease;\n}\n\n@keyframes arFadeIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.ar-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  outline: none;\n  transition: background 0.1s ease, color 0.1s ease;\n}\n\n.ar-item:hover,\n.ar-item[data-highlighted] {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.ar-item-selected {\n  color: var(--color-text-primary);\n}\n\n.ar-item-label {\n  font-family: var(--font-mono, monospace);\n  font-weight: 500;\n  flex: 1;\n}\n\n.ar-check {\n  margin-left: auto;\n  flex-shrink: 0;\n  opacity: 0.7;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Composer Model Dropdown\n   ═══════════════════════════════════════════════════════════════ */\n\n.mt-trigger {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  height: 32px;\n  padding: 0 8px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.mt-trigger:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.mt-trigger[data-state=\"open\"] {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.mt-trigger-icon {\n  flex-shrink: 0;\n  opacity: 0.7;\n}\n\n.mt-trigger-label {\n  font-weight: 500;\n  letter-spacing: -0.01em;\n}\n\n.mt-content {\n  min-width: 240px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 4px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n  animation: arFadeIn 0.12s ease;\n}\n\n/* ─── Composer LLM selector ─── */\n\n.llm-content {\n  min-width: 220px;\n}\n\n.llm-group + .llm-group {\n  margin-top: 4px;\n  padding-top: 4px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.llm-provider {\n  padding: 6px 8px 4px;\n  color: var(--color-text-secondary);\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  opacity: 0.65;\n}\n\n.llm-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 7px 8px;\n  border-radius: 5px;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  font-size: 11px;\n  outline: none;\n}\n\n.llm-item:hover,\n.llm-item[data-highlighted],\n.llm-item-selected {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.llm-check {\n  flex-shrink: 0;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Keyboard Shortcut Hint\n   ═══════════════════════════════════════════════════════════════ */\n\n.landing-shortcut-hint {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-top: 8px;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n.landing-shortcut-key {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 3px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  font-size: 10px;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-weight: 500;\n}\n\n.landing-shortcut-key svg {\n  width: 9px;\n  height: 9px;\n}\n\n.landing-shortcut-plus {\n  font-size: 10px;\n  font-weight: 500;\n  margin: 0 1px;\n}\n\n.landing-shortcut-text {\n  margin-left: 3px;\n  font-size: 11px;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Authenticated Home Templates\n   ═══════════════════════════════════════════════════════════════ */\n\n.landing-template-section {\n  width: 100%;\n  margin-top: 52px;\n  text-align: left;\n}\n\n.landing-template-section__header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 18px;\n  margin-bottom: 14px;\n}\n\n.landing-template-section__label {\n  display: block;\n  margin-bottom: 7px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n}\n\n.landing-template-section__title {\n  margin: 0;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 30px;\n  font-weight: 400;\n  line-height: 1.12;\n  color: var(--color-text-primary);\n}\n\n.landing-template-section__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  flex-shrink: 0;\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  font-size: 12px;\n  font-weight: 600;\n  transition: color 0.15s ease;\n}\n\n.landing-template-section__link:hover {\n  color: var(--color-text-primary);\n}\n\n.landing-template-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.landing-template-card {\n  appearance: none;\n  width: 100%;\n  min-height: 138px;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: start;\n  gap: 14px;\n  padding: 18px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  color: var(--color-text-primary);\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n}\n\n.landing-template-card:hover {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n  transform: translateY(-1px);\n}\n\n.landing-template-card__icon {\n  width: 38px;\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-accent-base);\n}\n\n.landing-template-card--blue .landing-template-card__icon {\n  color: #6f9ee8;\n}\n\n.landing-template-card--green .landing-template-card__icon {\n  color: #5fbf92;\n}\n\n.landing-template-card--teal .landing-template-card__icon {\n  color: #45b8c4;\n}\n\n.landing-template-card--yellow .landing-template-card__icon {\n  color: #d6a84f;\n}\n\n.landing-template-card--red .landing-template-card__icon {\n  color: #e47575;\n}\n\n.landing-template-card--pink .landing-template-card__icon {\n  color: #de7fa6;\n}\n\n.landing-template-card--cyan .landing-template-card__icon {\n  color: #56b6de;\n}\n\n.landing-template-card--lime .landing-template-card__icon {\n  color: #93c66c;\n}\n\n.landing-template-card__body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.landing-template-card__eyebrow {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n}\n\n.landing-template-card__title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--color-text-primary);\n}\n\n.landing-template-card__desc {\n  max-width: 44ch;\n  font-size: 12px;\n  line-height: 1.55;\n  color: var(--color-text-secondary);\n}\n\n.landing-template-card__arrow {\n  color: var(--color-text-secondary);\n  opacity: 0.75;\n  transition: transform 0.15s ease, color 0.15s ease;\n}\n\n.landing-template-card:hover .landing-template-card__arrow {\n  color: var(--color-text-primary);\n  transform: translateX(2px);\n}\n\n.landing-submit-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2200;\n  background: color-mix(in srgb, var(--color-bg-root) 88%, transparent 12%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.landing-submit-confirm-modal {\n  width: min(560px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 18px;\n}\n\n.landing-submit-confirm-title {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.landing-submit-confirm-text {\n  margin: 0 0 14px 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n}\n\n.landing-submit-confirm-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.landing-submit-confirm-secondary,\n.landing-submit-confirm-primary {\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  padding: 10px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.landing-submit-confirm-secondary {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n.landing-submit-confirm-primary {\n  background: var(--color-text-primary);\n  color: var(--color-bg-root);\n}\n\n.landing-submit-confirm-secondary:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.landing-submit-confirm-primary:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.landing-submit-confirm-secondary:disabled,\n.landing-submit-confirm-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Auth State\n   ═══════════════════════════════════════════════════════════════ */\n\n.landing-auth-state {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.landing-auth-state span {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.landing-auth-state button {\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.landing-auth-state button:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Responsive\n   ═══════════════════════════════════════════════════════════════ */\n\n@media (max-width: 720px) {\n  .landing-content.landing-authenticated .landing-main {\n    padding: 32px 16px 44px;\n  }\n\n  .landing-main {\n    gap: 24px;\n  }\n\n  .landing-title {\n    margin-top: 6vh;\n  }\n\n  .landing-announcement-chip {\n    font-size: 12px;\n    padding: 8px 12px;\n  }\n\n  .landing-upload-panel {\n    padding: 16px 20px 64px 20px;\n  }\n\n  .landing-submit-confirm-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .landing-upload-panel::after {\n    height: 64px;\n  }\n\n  .landing-upload-cta {\n    width: 40px;\n    height: 40px;\n    bottom: 14px;\n    right: 14px;\n  }\n\n  .landing-bottom-actions {\n    bottom: 14px;\n    left: 14px;\n  }\n\n  .landing-attach-button {\n    width: 30px;\n    height: 30px;\n  }\n\n  .ar-trigger {\n    height: 30px;\n    padding: 0 6px;\n    font-size: 10px;\n  }\n\n  .mt-trigger {\n    height: 30px;\n    padding: 0 6px;\n    font-size: 10px;\n  }\n\n  .landing-template-section {\n    margin-top: 38px;\n  }\n\n  .landing-template-section__header {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .landing-template-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .landing-template-card {\n    min-height: 126px;\n    padding: 16px;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Drag Overlay\n   ═══════════════════════════════════════════════════════════════ */\n\n.landing-drag-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--color-bg-root);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.landing-drag-message {\n  font-size: 24px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  padding: 32px 48px;\n  border: 1px dashed var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Video Gallery Section\n   ═══════════════════════════════════════════════════════════════ */\n\n.gallery-section {\n  max-width: 1100px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 48px clamp(20px, 5vw, 48px) 80px;\n  position: relative;\n  z-index: 5;\n  text-align: center;\n}\n\n.gallery-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(28px, 4vw, 44px);\n  font-weight: 400;\n  color: var(--color-text-primary);\n  text-align: center;\n  margin: 0 0 40px 0;\n}\n\n.gallery-title-brand {\n  color: var(--color-text-primary);\n  font-style: italic;\n}\n\n.gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.gallery-card {\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.gallery-card:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.gallery-card-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n}\n\n.gallery-card-title {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n}\n\n.gallery-card-likes {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.gallery-item {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  aspect-ratio: 4 / 3;\n  background: var(--color-bg-input);\n}\n\n.gallery-item:hover {\n  opacity: 0.85;\n}\n\n.gallery-item-media {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.gallery-thumbnail {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: opacity 0.2s ease;\n}\n\n.gallery-thumbnail-hidden {\n  opacity: 0;\n}\n\n.gallery-video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.gallery-video-visible {\n  opacity: 1;\n}\n\n.gallery-item-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.6) 0%,\n    rgba(0, 0, 0, 0.2) 40%,\n    transparent 100%\n  );\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 14px;\n  pointer-events: none;\n}\n\n.gallery-item-title {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.95);\n  letter-spacing: 0.01em;\n}\n\n.gallery-item-play {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(0.9);\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-primary);\n  opacity: 0;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n  border: 1px solid var(--color-border-input);\n}\n\n.gallery-item:hover .gallery-item-play {\n  opacity: 1;\n  transform: translate(-50%, -50%) scale(1);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Video Modal\n   ═══════════════════════════════════════════════════════════════ */\n\n.video-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  animation: modalFadeIn 0.2s ease;\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.video-modal-container {\n  position: relative;\n  max-width: 900px;\n  width: 100%;\n  animation: modalSlideIn 0.25s ease;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.video-modal-close {\n  position: absolute;\n  top: -40px;\n  right: 0;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  border-radius: 4px;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.video-modal-close:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.video-modal-content {\n  background: var(--color-bg-canvas-surface);\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n}\n\n.video-modal-player {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  display: block;\n  background: var(--color-bg-input);\n}\n\n.video-modal-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 18px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  margin: 0;\n  padding: 14px 20px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Gallery Responsive\n   ═══════════════════════════════════════════════════════════════ */\n\n@media (max-width: 900px) {\n  .gallery-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n}\n\n@media (max-width: 600px) {\n  .gallery-section {\n    padding: 32px 20px 64px;\n  }\n  \n  .gallery-title {\n    margin-bottom: 24px;\n  }\n  \n  .gallery-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n  \n  .gallery-item {\n    aspect-ratio: 16 / 10;\n  }\n  \n  .video-modal-backdrop {\n    padding: 20px;\n  }\n  \n  .video-modal-close {\n    top: -36px;\n  }\n  \n  .video-modal-title {\n    font-size: 16px;\n    padding: 12px 16px;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Footer Section\n   ═══════════════════════════════════════════════════════════════ */\n\n.landing-footer {\n  background: var(--color-bg-canvas-surface);\n  border-top: 1px solid var(--color-border-input);\n  position: relative;\n  z-index: 5;\n}\n\n.footer-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 48px clamp(20px, 5vw, 40px) 32px;\n}\n\n.footer-top {\n  display: grid;\n  grid-template-columns: 2fr repeat(4, 1fr);\n  gap: 32px;\n  padding-bottom: 40px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.footer-brand {\n  max-width: 240px;\n}\n\n.footer-logo-img {\n  height: 40px;\n  width: auto;\n  margin: 0 0 12px 0;\n  opacity: 0.8;\n}\n\n.footer-tagline {\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n  margin: 0 0 16px 0;\n}\n\n.footer-social {\n  display: flex;\n  gap: 8px;\n}\n\n.footer-social-link {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n  transition: all 0.15s ease;\n}\n\n.footer-social-link:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.footer-links-group {\n  min-width: 0;\n}\n\n.footer-links-title {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-text-secondary);\n  margin: 0 0 14px 0;\n}\n\n.footer-links {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.footer-links li a {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.footer-links li a:hover {\n  color: var(--color-text-primary);\n}\n\n/* Newsletter section */\n.footer-newsletter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 32px;\n  padding: 32px 0;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.footer-newsletter-content {\n  flex: 1;\n}\n\n.footer-newsletter-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 18px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  margin: 0 0 4px 0;\n}\n\n.footer-newsletter-desc {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n.footer-newsletter-form {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.footer-newsletter-input {\n  width: 240px;\n  padding: 10px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  font-size: 13px;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  color: var(--color-text-primary);\n  outline: none;\n  transition: border-color 0.15s ease;\n}\n\n.footer-newsletter-input::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.footer-newsletter-input:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.footer-newsletter-btn {\n  padding: 10px 20px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.footer-newsletter-btn:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n/* Footer bottom */\n.footer-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 24px;\n}\n\n.footer-copyright {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n.footer-bottom-links {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.footer-bottom-links a {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.footer-bottom-links a:hover {\n  color: var(--color-text-primary);\n}\n\n.footer-dot {\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  opacity: 0.5;\n}\n\n/* Footer Responsive */\n@media (max-width: 1024px) {\n  .footer-top {\n    grid-template-columns: 1fr 1fr;\n    gap: 28px;\n  }\n  \n  .footer-brand {\n    grid-column: span 2;\n    max-width: 100%;\n  }\n  \n  .footer-social {\n    margin-bottom: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-inner {\n    padding: 40px 20px 24px;\n  }\n  \n  .footer-top {\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n  }\n  \n  .footer-newsletter {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .footer-newsletter-form {\n    width: 100%;\n  }\n  \n  .footer-newsletter-input {\n    flex: 1;\n    width: auto;\n    min-width: 0;\n  }\n  \n  .footer-bottom {\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-top {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n  \n  .footer-brand {\n    grid-column: span 1;\n  }\n  \n  .footer-newsletter-form {\n    flex-direction: column;\n  }\n  \n  .footer-newsletter-btn {\n    width: 100%;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Features Section - Killer Features Showcase\n   ═══════════════════════════════════════════════════════════════ */\n\n.ft-section-label {\n  display: inline-block;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--color-accent-base);\n  margin-bottom: 16px;\n  padding: 5px 12px;\n  border: 1px solid var(--color-accent-base);\n  border-radius: 3px;\n  opacity: 0.85;\n}\n\n/* ─── Composer Section ─── */\n\n.composer-section {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 80px clamp(20px, 5vw, 48px);\n  position: relative;\n  z-index: 5;\n}\n\n.composer-inner {\n  opacity: 0;\n  transform: translateY(32px);\n  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),\n              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.composer-inner--visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.composer-header {\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.composer-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(28px, 4vw, 44px);\n  font-weight: 400;\n  line-height: 1.15;\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.composer-title-em {\n  font-style: italic;\n  color: var(--color-accent-base);\n}\n\n.composer-content {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 48px;\n  align-items: center;\n}\n\n.composer-animation {\n  position: relative;\n  aspect-ratio: 4 / 3;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.composer-anim-step {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  transform: scale(0.97) translateY(8px);\n  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),\n              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  will-change: opacity, transform;\n}\n\n.composer-anim-step--active {\n  opacity: 1;\n  transform: scale(1) translateY(0);\n}\n\n.composer-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.composer-step {\n  all: unset;\n  display: flex;\n  gap: 16px;\n  padding: 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  opacity: 0.4;\n  transform: translateX(0);\n  transition: opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1),\n              background 0.5s cubic-bezier(0.16, 1, 0.3, 1),\n              transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n  align-items: flex-start;\n  text-align: left;\n}\n\n.composer-step--active {\n  opacity: 1;\n  background: var(--color-bg-canvas-surface);\n  transform: translateX(4px);\n}\n\n.composer-step:hover {\n  opacity: 0.7;\n}\n\n.composer-step--active:hover {\n  opacity: 1;\n}\n\n.composer-step-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  border-radius: 50%;\n  border: 1px solid var(--color-border-input);\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 16px;\n  color: var(--color-text-primary);\n  margin-top: 2px;\n}\n\n.composer-step--active .composer-step-number {\n  background: var(--color-accent-base);\n  border-color: var(--color-accent-base);\n  color: #fff;\n}\n\n.composer-step-text {\n  flex: 1;\n}\n\n.composer-step-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 20px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  margin: 0 0 6px;\n  line-height: 1.2;\n}\n\n.composer-step-desc {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* ─── Composer Animation Internals ─── */\n\n/* Step 1: Prompt */\n.canim-prompt {\n  width: 100%;\n  padding: 8px;\n}\n\n.canim-prompt-box {\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.canim-prompt-header {\n  display: flex;\n  gap: 5px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.canim-prompt-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--color-text-secondary);\n  opacity: 0.25;\n}\n\n.canim-prompt-body {\n  padding: 16px;\n  min-height: 80px;\n}\n\n.canim-prompt-text {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--color-text-primary);\n  display: inline;\n}\n\n.canim-prompt-cursor {\n  display: inline-block;\n  width: 2px;\n  height: 1em;\n  background: var(--color-accent-base);\n  vertical-align: text-bottom;\n  margin-left: 1px;\n  animation: composerBlink 0.7s step-end infinite;\n}\n\n.canim-prompt-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.canim-prompt-attach {\n  color: var(--color-text-secondary);\n  opacity: 0.5;\n}\n\n.canim-prompt-send {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 14px;\n  transition: background 0.3s ease, color 0.3s ease;\n}\n\n.canim-prompt-send--active {\n  background: var(--color-accent-base);\n  color: #fff;\n  transition-delay: 2.8s;\n}\n\n\n@keyframes composerBlink {\n  50% { border-color: transparent; }\n}\n\n/* Step 2: Editor */\n.canim-editor {\n  width: 100%;\n  padding: 8px;\n}\n\n.canim-editor-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.canim-editor-status--visible {\n  opacity: 1;\n  transition-delay: 0.2s;\n}\n\n.canim-editor-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid var(--color-border-input);\n  border-top-color: var(--color-accent-base);\n  border-radius: 50%;\n  animation: composerSpin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n.canim-editor-status-text {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--color-accent-base);\n}\n\n@keyframes composerSpin {\n  to { transform: rotate(360deg); }\n}\n\n.canim-editor-toolbar {\n  display: flex;\n  gap: 6px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--color-border-input);\n  background: var(--color-bg-root);\n  border-radius: 8px 8px 0 0;\n  border: 1px solid var(--color-border-input);\n  border-bottom: none;\n}\n\n.canim-editor-toolbar-item {\n  width: 24px;\n  height: 8px;\n  border-radius: 2px;\n  background: var(--color-text-secondary);\n  opacity: 0.15;\n}\n\n.canim-editor-toolbar-spacer {\n  flex: 1;\n  background: none;\n}\n\n.canim-editor-toolbar-item--wide {\n  width: 48px;\n}\n\n.canim-editor-tracks {\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 0 0 8px 8px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.canim-editor-track {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 40px;\n}\n\n.canim-editor-track-label {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  opacity: 0.5;\n  width: 16px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.canim-editor-clip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  opacity: 0;\n  transform: translateX(-20px);\n}\n\n.canim-editor-clip--in {\n  animation: composerSlideIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.canim-editor-clip--v1.canim-editor-clip--in { animation-delay: 0.3s; }\n.canim-editor-clip--v2.canim-editor-clip--in { animation-delay: 0.7s; }\n.canim-editor-clip--v3.canim-editor-clip--in { animation-delay: 1.1s; }\n.canim-editor-clip--audio.canim-editor-clip--in { animation-delay: 1.5s; }\n\n.canim-editor-clip-thumb {\n  width: 24px;\n  height: 16px;\n  border-radius: 2px;\n  background: var(--color-accent-base);\n  opacity: 0.4;\n  flex-shrink: 0;\n}\n\n.canim-editor-clip--audio .canim-editor-clip-thumb {\n  display: none;\n}\n\n.canim-editor-clip-wave {\n  width: 60px;\n  height: 12px;\n  border-radius: 2px;\n  background: repeating-linear-gradient(\n    90deg,\n    var(--color-accent-base) 0px,\n    var(--color-accent-base) 2px,\n    transparent 2px,\n    transparent 4px\n  );\n  opacity: 0.3;\n  flex-shrink: 0;\n}\n\n.canim-editor-clip-name {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 10px;\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n}\n\n@keyframes composerSlideIn {\n  from { transform: translateX(-20px); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n}\n\n/* Step 3: Export */\n\n.canim-export-timeline {\n  width: 100%;\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.canim-export-track {\n  display: flex;\n  gap: 6px;\n}\n\n.canim-export-clip {\n  flex: 1;\n  height: 40px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: flex 1s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.canim-export-clip--trimmed {\n  flex: 0.6;\n}\n\n.canim-export-clip-inner {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 10px;\n  color: var(--color-text-secondary);\n}\n\n.canim-export-cursor {\n  position: absolute;\n  color: var(--color-text-primary);\n  opacity: 0;\n  top: 28px;\n  left: 42%;\n  transition: opacity 0.3s ease, top 0.6s cubic-bezier(0.16, 1, 0.3, 1), left 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n  pointer-events: none;\n  z-index: 2;\n}\n\n.canim-export-cursor--visible {\n  opacity: 1;\n}\n\n.canim-export-cursor--at-clip {\n  top: 28px;\n  left: 42%;\n}\n\n.canim-export-cursor--trimming {\n  top: 32px;\n  left: 32%;\n}\n\n.canim-export-cursor--at-btn {\n  top: 96px;\n  left: 48%;\n}\n\n.canim-export {\n  width: 100%;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  position: relative;\n}\n\n.canim-export-btn {\n  all: unset;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 24px;\n  border-radius: 6px;\n  background: var(--color-accent-base);\n  color: #fff;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  opacity: 0;\n  transform: scale(0.9);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n}\n\n.canim-export-btn--visible {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.canim-export-btn--clicked {\n  animation: composerButtonPulse 0.3s ease;\n}\n\n@keyframes composerButtonPulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(0.92); }\n}\n\n/* ─── Numbers Section ─── */\n\n.numbers-section {\n  padding: 80px clamp(20px, 5vw, 48px);\n  position: relative;\n  z-index: 5;\n}\n\n.numbers-inner {\n  max-width: 1000px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),\n              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.numbers-inner--visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.numbers-card {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  padding: 40px 32px;\n  text-align: center;\n  opacity: 0;\n  transform: translateY(16px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.numbers-card--visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.numbers-value {\n  display: block;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(36px, 5vw, 56px);\n  font-weight: 400;\n  color: var(--color-text-primary);\n  line-height: 1;\n  margin-bottom: 12px;\n}\n\n.numbers-label {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n}\n\n/* ─── Get Started Section ─── */\n\n.ft-get-started {\n  padding: 68px clamp(20px, 5vw, 48px) 86px;\n  background: var(--color-bg-canvas-surface);\n  border-top: 1px solid var(--color-border-input);\n}\n\n.ft-get-started__inner {\n  max-width: 1120px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.25fr);\n  align-items: center;\n  gap: 30px;\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),\n              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ft-get-started__inner--visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.ft-get-started__content {\n  text-align: left;\n}\n\n.ft-get-started__title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(28px, 3.6vw, 46px);\n  font-weight: 400;\n  line-height: 1.08;\n  letter-spacing: -0.01em;\n  color: var(--color-text-primary);\n  margin: 0 0 16px;\n}\n\n.ft-get-started__desc {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 14px;\n  line-height: 1.7;\n  color: var(--color-text-secondary);\n  max-width: 460px;\n  margin: 0 0 28px;\n}\n\n.ft-get-started__cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  border-radius: 4px;\n  padding: 12px 16px;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;\n}\n\n.ft-get-started__cta:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 20px -12px rgba(15, 18, 24, 0.45);\n}\n\n.ft-get-started__cta:active {\n  transform: translateY(0);\n}\n\n.ft-get-started__cta-arrow {\n  font-size: 14px;\n  transition: transform 0.18s ease;\n}\n\n.ft-get-started__cta:hover .ft-get-started__cta-arrow {\n  transform: translateX(2px);\n}\n\n.ft-get-started__preview {\n  position: relative;\n}\n\n.ft-get-started__preview::before {\n  content: \"\";\n  position: absolute;\n  inset: -10px -10px auto auto;\n  width: 72%;\n  height: 62%;\n  background: radial-gradient(\n    circle at top right,\n    color-mix(in srgb, var(--color-accent-base) 30%, transparent),\n    transparent 70%\n  );\n  pointer-events: none;\n  z-index: 0;\n  opacity: 0.45;\n}\n\n.ft-get-started__frame {\n  position: relative;\n  z-index: 1;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  box-shadow: 0 20px 46px -28px rgba(15, 18, 24, 0.55);\n}\n\n.ft-get-started__frame-top {\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n  border-bottom: 1px solid var(--color-border-input);\n  background: color-mix(in srgb, var(--color-bg-root) 55%, var(--color-bg-canvas-surface));\n}\n\n.ft-get-started__dots {\n  display: inline-flex;\n  gap: 6px;\n}\n\n.ft-get-started__dots span {\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n  background: var(--color-border-input);\n}\n\n.ft-get-started__frame-label {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n}\n\n.ft-get-started__image {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.ft-get-started__chip {\n  position: absolute;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border-input);\n  background: color-mix(in srgb, var(--color-bg-canvas-surface) 86%, transparent);\n  backdrop-filter: blur(3px);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  animation: ftChipFloat 4.4s ease-in-out infinite;\n}\n\n.ft-get-started__chip::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--color-accent-base);\n  opacity: 0.9;\n}\n\n.ft-get-started__chip--one {\n  left: -14px;\n  top: 52px;\n}\n\n.ft-get-started__chip--two {\n  right: -12px;\n  top: 110px;\n  animation-delay: 0.5s;\n}\n\n.ft-get-started__chip--three {\n  left: 30px;\n  bottom: 18px;\n  animation-delay: 1s;\n}\n\n@keyframes ftChipFloat {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-4px);\n  }\n}\n\n/* ─── Automation Section ─── */\n\n.automation-section {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 80px clamp(20px, 5vw, 48px);\n  position: relative;\n  z-index: 5;\n}\n\n.automation-inner {\n  opacity: 0;\n  transform: translateY(32px);\n  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),\n              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.automation-inner--visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.automation-header {\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.automation-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(28px, 4vw, 44px);\n  font-weight: 400;\n  line-height: 1.15;\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.automation-title-em {\n  font-style: italic;\n  color: var(--color-accent-base);\n}\n\n.automation-subtitle {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--color-text-secondary);\n  margin: 12px auto 0;\n  max-width: 520px;\n}\n\n.automation-content {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 48px;\n  align-items: center;\n}\n\n.automation-animation {\n  position: relative;\n  aspect-ratio: 4 / 3;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n/* ─── Automation Anim: Ideate ─── */\n\n.aauto-ideate {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 12px;\n}\n\n.aauto-ideate-product,\n.aauto-ideate-persona {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 18px;\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  opacity: 0;\n  transform: translateY(12px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.aauto-ideate-product--in,\n.aauto-ideate-persona--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.aauto-ideate-product-img,\n.aauto-ideate-persona-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n  background: var(--color-bg-canvas-surface);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n}\n\n.aauto-ideate-product-label,\n.aauto-ideate-persona-label {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.aauto-ideate-plus {\n  font-size: 20px;\n  color: var(--color-text-secondary);\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.aauto-ideate-plus--in {\n  opacity: 0.5;\n}\n\n.aauto-ideate-arrow {\n  opacity: 0;\n  transform: translateX(-8px);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n  color: var(--color-text-secondary);\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.aauto-ideate-arrow--in {\n  opacity: 0.5;\n  transform: translateX(0);\n}\n\n.aauto-ideate-ideas {\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  padding: 12px 16px;\n  min-width: 220px;\n  opacity: 0;\n  transform: translateY(10px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.aauto-ideate-ideas--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.aauto-ideate-ideas-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.aauto-ideate-idea {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  padding: 5px 0;\n  opacity: 0;\n  transform: translateX(-8px);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n}\n\n.aauto-ideate-idea--in {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.aauto-ideate-idea-dot {\n  width: 5px;\n  height: 5px;\n  min-width: 5px;\n  border-radius: 50%;\n  background: var(--color-accent-base);\n}\n\n/* ─── Automation Anim: Generate ─── */\n\n.aauto-generate {\n  width: 100%;\n  padding: 16px;\n}\n\n.aauto-generate-composer {\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.aauto-generate-composer--in {\n  opacity: 1;\n}\n\n.aauto-generate-composer-header {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.aauto-generate-composer-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--color-text-secondary);\n  opacity: 0.25;\n}\n\n.aauto-generate-composer-title {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  margin-left: 8px;\n  font-weight: 500;\n}\n\n.aauto-generate-preview {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  padding: 16px;\n}\n\n.aauto-generate-frame {\n  aspect-ratio: 9 / 16;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  opacity: 0;\n  transform: scale(0.9);\n  transition: opacity 0.6s ease, transform 0.6s ease;\n}\n\n.aauto-generate-frame--in {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.aauto-generate-frame--1 { transition-delay: 0ms; }\n.aauto-generate-frame--2 { transition-delay: 200ms; }\n.aauto-generate-frame--3 { transition-delay: 400ms; }\n\n.aauto-generate-frame-shimmer {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    110deg,\n    transparent 30%,\n    var(--color-accent-base-transparent, rgba(99, 102, 241, 0.06)) 50%,\n    transparent 70%\n  );\n  background-size: 200% 100%;\n  animation: aautoShimmer 2s ease-in-out infinite;\n}\n\n@keyframes aautoShimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.aauto-generate-frame-icon {\n  color: var(--color-text-secondary);\n  opacity: 0.3;\n  z-index: 1;\n}\n\n.aauto-generate-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 16px;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 11px;\n  color: var(--color-accent-base);\n  font-weight: 500;\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.aauto-generate-status--in {\n  opacity: 1;\n}\n\n.aauto-generate-spinner {\n  width: 12px;\n  height: 12px;\n  border: 2px solid var(--color-border-input);\n  border-top-color: var(--color-accent-base);\n  border-radius: 50%;\n  animation: aautoSpin 0.8s linear infinite;\n}\n\n@keyframes aautoSpin {\n  to { transform: rotate(360deg); }\n}\n\n.aauto-generate-bar {\n  height: 3px;\n  margin: 10px 16px 14px;\n  background: var(--color-bg-canvas-surface);\n  border-radius: 2px;\n  overflow: hidden;\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.aauto-generate-bar--in {\n  opacity: 1;\n}\n\n.aauto-generate-bar-fill {\n  height: 100%;\n  width: 0%;\n  background: var(--color-accent-base);\n  border-radius: 2px;\n  transition: width 1.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.aauto-generate-bar-fill--mid {\n  width: 60%;\n}\n\n.aauto-generate-bar-fill--done {\n  width: 100%;\n}\n\n/* ─── Automation Anim: Publish ─── */\n\n.aauto-publish {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding: 16px;\n  position: relative;\n}\n\n.aauto-publish-source {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  opacity: 0;\n  transform: translateY(-8px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.aauto-publish-source--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.aauto-publish-thumb {\n  width: 36px;\n  height: 36px;\n  background: var(--color-bg-canvas-surface);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n}\n\n.aauto-publish-source-label {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.aauto-publish-arrows {\n  display: flex;\n  gap: 24px;\n  justify-content: center;\n  height: 20px;\n}\n\n.aauto-publish-arrow {\n  width: 2px;\n  height: 0;\n  background: var(--color-accent-base);\n  opacity: 0.4;\n  border-radius: 1px;\n  transition: height 0.5s ease;\n}\n\n.aauto-publish-arrow--in {\n  height: 20px;\n}\n\n.aauto-publish-arrow--1 { transition-delay: 0ms; }\n.aauto-publish-arrow--2 { transition-delay: 100ms; }\n.aauto-publish-arrow--3 { transition-delay: 200ms; }\n\n.aauto-publish-platforms {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.aauto-publish-platform {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  opacity: 0;\n  transform: translateY(10px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.aauto-publish-platform--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.aauto-publish-platform svg {\n  color: var(--color-text-secondary);\n}\n\n.aauto-publish-check {\n  color: #22c55e;\n  font-weight: 700;\n  opacity: 0;\n  transform: scale(0);\n  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.aauto-publish-check--in {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.aauto-publish-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  background: var(--color-accent-base);\n  color: #fff;\n  border-radius: 20px;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  opacity: 0;\n  transform: translateY(6px);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n}\n\n.aauto-publish-badge--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* ─── Automation Anim: Repeat & Scale ─── */\n\n.aauto-repeat {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding: 16px;\n}\n\n/* Schedule badge */\n.aauto-repeat-schedule {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 16px;\n  background: var(--color-accent-base);\n  color: #fff;\n  border-radius: 20px;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  opacity: 0;\n  transform: translateY(-8px);\n  transition: opacity 0.45s ease, transform 0.45s ease;\n}\n\n.aauto-repeat-schedule--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Pipeline row */\n.aauto-repeat-pipeline {\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n.aauto-repeat-pipe-step {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  opacity: 0;\n  transform: translateY(8px);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n}\n\n.aauto-repeat-pipe-step--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.aauto-repeat-pipe-icon {\n  display: flex;\n  color: var(--color-accent-base);\n}\n\n.aauto-repeat-pipe-arrow {\n  margin: 0 2px 0 8px;\n  font-size: 16px;\n  color: var(--color-text-secondary);\n  opacity: 0.4;\n}\n\n.aauto-repeat-pipe-label {\n  white-space: nowrap;\n}\n\n/* Loop-back bar */\n.aauto-repeat-loopback {\n  position: relative;\n  width: 85%;\n  height: 24px;\n  opacity: 0;\n  transition: opacity 0.5s ease;\n}\n\n.aauto-repeat-loopback--in {\n  opacity: 1;\n}\n\n.aauto-repeat-loopback--in .aauto-repeat-loopback-path {\n  animation: aautoLoopDash 1.8s linear infinite;\n}\n\n@keyframes aautoLoopDash {\n  to { stroke-dashoffset: -28; }\n}\n\n.aauto-repeat-loopback-label {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 9px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-accent-base);\n  background: var(--color-bg-canvas-surface);\n  padding: 0 8px;\n}\n\n/* Scaling accounts */\n.aauto-repeat-accounts {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: center;\n  opacity: 0;\n  transform: translateY(10px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.aauto-repeat-accounts--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.aauto-repeat-account {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  opacity: 0;\n  transform: scale(0.9);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n}\n\n.aauto-repeat-accounts--in .aauto-repeat-account {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.aauto-repeat-account--in {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.aauto-repeat-account--add {\n  border-style: dashed;\n  cursor: pointer;\n}\n\n.aauto-repeat-account-avatar {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--color-accent-base);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.aauto-repeat-account-name {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n}\n\n.aauto-repeat-status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #22c55e;\n}\n\n.aauto-repeat-account-plus {\n  font-size: 16px;\n  color: var(--color-text-secondary);\n  line-height: 1;\n}\n\n/* ─── Sections Responsive ─── */\n\n@media (max-width: 900px) {\n  .composer-content,\n  .automation-content {\n    grid-template-columns: 1fr;\n  }\n\n  .ft-get-started__inner {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .ft-get-started__content {\n    text-align: center;\n  }\n\n  .ft-get-started__desc {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .ft-get-started__chip--one {\n    left: 10px;\n  }\n\n  .ft-get-started__chip--two {\n    right: 10px;\n  }\n}\n\n@media (max-width: 600px) {\n  .composer-section,\n  .automation-section {\n    padding: 60px 20px;\n  }\n\n  .composer-animation,\n  .automation-animation {\n    aspect-ratio: 16 / 10;\n  }\n\n  .numbers-inner {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .numbers-card {\n    padding: 28px 24px;\n  }\n\n  .ft-get-started {\n    padding: 46px 20px 60px;\n  }\n\n  .ft-get-started__title {\n    font-size: clamp(26px, 9vw, 38px);\n  }\n\n  .ft-get-started__cta {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .ft-get-started__chip {\n    position: static;\n    margin-top: 8px;\n    margin-right: 6px;\n  }\n\n  .ft-get-started__chip--one,\n  .ft-get-started__chip--two,\n  .ft-get-started__chip--three {\n    left: auto;\n    right: auto;\n    top: auto;\n    bottom: auto;\n  }\n\n  .ft-get-started__preview {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0;\n  }\n\n  .ft-get-started__frame {\n    width: 100%;\n  }\n}\n\n/* ─── Landing showcase (compact single row from ExamplesPage) ─── */\n\n.landing-showcase {\n  padding: 48px 0 80px;\n}\n\n.landing-showcase-inner {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 clamp(20px, 4vw, 48px);\n  gap: 0;\n}\n\n.landing-showcase .ex-category-head .ft-section-label {\n  display: inline-block;\n  margin-bottom: 8px;\n}\n\n.landing-showcase .ex-category-head {\n  margin-bottom: -20px;\n  align-items: center;\n}\n\n.landing-showcase .ex-scroller-track {\n  padding-top: 0;\n}\n\n.landing-showcase .ex-scroller::before,\n.landing-showcase .ex-scroller::after {\n  top: 0;\n}\n\n.landing-showcase-cta {\n  display: flex;\n  justify-content: center;\n  margin-top: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
